import { UserService } from "@/services";
import { util } from "@/helpers";
import { ERROR_CODES } from "@/utils/constants";
import { CommonClass } from "@/mixins";
import { clearMemberIdRequestID } from "@/router";
import sessionStorageUtils from "@/utils/session-storage";
const {
  MIDERR_001,
  MIDERR_003,
  MIDERR_004,
  MIDERR_007,
  MIDERR_009,
  MIDERR_010,
  MIDERR_014,
  MIDERR_018,
  MIDERR_008,
  MIDERR_017,
  MIDERR_020,
  MIDERR_022,
  MIDERR_023,
  MIDERR_024,
  MIDERR_025,
  MIDERR_021,
  MIDERR_011,
  MIDERR_026,
  MIDERR_038,
  MIDERR_046,
  // MIDERR_027,
  // MIDERR_028,
  MIDERR_015,
  MIDERR_016,
  // MIDERR_034,
  // MIDERR_035,
  MIDERR_037,
} = ERROR_CODES;

const channelId = sessionStorageUtils.getItem("ChannelId") || setChannelId();
const channelType = channelId?.includes("MO-APP") ? "MO" : "FO";

function setChannelId() {
  const channelId = CommonClass.methods.$__checkChannelId()
  sessionStorageUtils.setItem("ChannelId", channelId);
  return channelId
}

export default {
  async fetchIsamMemberId(context, requestId) {
    try {
      const response = await UserService.getMemberId(requestId);
      const data = CommonClass.methods.$__processDecryptResponse(response.data, process.env.VUE_APP_ENCODEKEY);
      const memberId = data?.memberId;
      return typeof memberId === "string" ? memberId : "";
    } catch (error) {
      return "";
    }
  },

  async loginFlow({ commit }, payload) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    let respData;
    try {
      const response = await UserService.login(payload);
      const data = CommonClass.methods.$__processDecryptResponse(response.data, process.env.VUE_APP_ENCODEKEY);
      respData = data;
      // console.log("login data here ", data);
      if (data?.successFlag) {
        if (
          data?.stepName === "SN_TRIGGER_SMS_OTP" ||
          data?.stepName === "SN_VERIFY_SMS_OTP" ||
          data?.stepName === "SN_TRIGGER_EMAIL_OTP" ||
          data?.stepName === "SN_VERIFY_EMAIL_OTP"
        ) {
          commit("SET_STATUS", 1);
          commit("SET_OTP_DATA", data);
        } else {
          commit("SET_STATUS", 1);
          commit("SET_RESPONSE", data);
        }
        sessionStorageUtils.deleteItem("activeRawId");
        return data;
      } else {
        commit("SET_STATUS", 2);
        const errCode = data?.errCode;
        const msg = util.getUiErrorByCode(errCode);
        // if (msg) {
        //   window.dataLayerPush({
        //     event: "trackEvent",
        //     "eventDetails.category": "GID - login",
        //     "eventDetails.action": "click",
        //     "eventDetails.label": "continue - unsuccessful GID login - " + msg,
        //     journeyType: "GID login",
        //   });
        // }
        if (msg && errCode != "MIDERR_045") {
          window.dataLayerPush({
            event: "attempt_login",
            "eventDetails.category": "MID - login",
            "eventDetails.label": "next - unsuccessful EB username login - " + msg,
            journeyType: channelType + " EB login",
            appId: channelType + " EB login",
          });
        }
        if (data?.stepName === "SN_VERIFY_SMS_OTP" || data?.stepName === "SN_VERIFY_EMAIL_OTP") {
          window.dataLayerPush({
            event: "attempt_login",
            "eventDetails.category": "MID - login",
            "eventDetails.label": "submit - unsuccessful EB mobile OTP - " + msg,
            journeyType: channelType + " EB login",
            appId: channelType + " EB login",
          });
        }
        if (errCode === "MIDERR_045") {
          try {
            window.dataLayerPush({
              event: "attempt_login",
              "eventDetails.category": "MID - login",
              "eventDetails.label": "continue - unsuccessful biometrics EB login - " + msg,
              journeyType: "FO EB biometric login - auto/manual/email/passkey",
              appId: "FO EB Biometric login",
            });
          } catch (error) {
            console.log(error);
          }
          const activeRawId = sessionStorageUtils.getItem("activeRawId");
          sessionStorageUtils.deleteItem("activeRawId");
          const sessionFidoUsers = JSON.parse(
            localStorage.getItem("fidoUsersObject")
          );
          if (sessionFidoUsers) {
            sessionFidoUsers.fidoUsers = sessionFidoUsers?.fidoUsers?.filter(
              (el) => activeRawId !== el.rawId
            );
            if (!sessionFidoUsers.fidoUsers.length) {
              localStorage.removeItem("fidoUsersObject");
            } else {
              localStorage.setItem(
                "fidoUsersObject",
                JSON.stringify(sessionFidoUsers)
              );
            }
          }
        }
        if (
          ![MIDERR_001, 
            MIDERR_004, // OTP errCode
            MIDERR_007, 
            MIDERR_015, //OTP errCode
            MIDERR_016, //OTP errCode
            MIDERR_020, 
            MIDERR_026, 
            MIDERR_037, //OTP errCode
            MIDERR_038 
          ].includes(errCode)
        ) {
          const errMsg = util.getUiErrorByCode(errCode);
          commit(
            "alert/SHOW_ALERT",
            {
              message: errMsg,
              type: "error",
            },
            { root: true }
          );
          document.getElementById("app").scrollIntoView({ behavior: "smooth" });
        }
      }
    } catch (e) {
      commit("SET_STATUS", 2);
      const respData = CommonClass.methods.$__processDecryptResponse(e.response.data, process.env.VUE_APP_ENCODEKEY);
      commit("SET_RESPONSE", respData);
      const errCode =
        respData?.errCode || e?.response?.status || MIDERR_025;
      const msg = util.getUiErrorByCode(errCode);
      if (
          respData?.stepName === "SN_VERIFY_SMS_OTP" ||
          respData?.stepName === "SN_VERIFY_EMAIL_OTP"
      ) {
          const otpType =
              respData.stepName === "SN_VERIFY_EMAIL_OTP" ? "email" : "mobile"
          window.dataLayerPush({
              event: "attempt_login",
              "eventDetails.category": "MID - login",
              "eventDetails.label": `submit - unsuccessful EB ${otpType} OTP - ${msg}`,
              journeyType: channelType + " EB login",
              appId: channelType + " EB login",
          })
      } else if (msg && errCode != "MIDERR_045") {
          window.dataLayerPush({
              event: "attempt_login",
              "eventDetails.category": "MID - login",
              "eventDetails.label":
                  "next - unsuccessful EB username login - " + msg,
              journeyType: channelType + " EB login",
              appId: channelType + " EB login",
          })
      }
      if (errCode === "MIDERR_045") {
        try {
          window.dataLayerPush({
            event: "attempt_login",
            "eventDetails.category": "MID - login",
            "eventDetails.label": "continue - unsuccessful biometrics EB login - " + msg,
            journeyType: "FO EB biometric login - auto/manual/email/passkey",
            appId: "FO EB Biometric login",
          });
        } catch (error) {
          console.log(error);
        }
        const activeRawId = sessionStorageUtils.getItem("activeRawId");
        sessionStorageUtils.deleteItem("activeRawId");
        const sessionFidoUsers = JSON.parse(
          localStorage.getItem("fidoUsersObject")
        );
        if (sessionFidoUsers) {
          sessionFidoUsers.fidoUsers = sessionFidoUsers?.fidoUsers?.filter(
            (el) => activeRawId !== el.rawId
          );
          if (!sessionFidoUsers.fidoUsers.length) {
            localStorage.removeItem("fidoUsersObject");
          } else {
            localStorage.setItem(
              "fidoUsersObject",
              JSON.stringify(sessionFidoUsers)
            );
          }
        }
      }
      if (
        ![MIDERR_001, 
          MIDERR_004, // OTP errCode
          MIDERR_007,
          MIDERR_015, 
          MIDERR_016, //OTP errCode
          MIDERR_020, 
          MIDERR_026, 
          MIDERR_037, //OTP errCode
          MIDERR_038 
        ].includes(errCode)
      ) {
        const errMsg = util.getUiErrorByCode(errCode);
        commit(
          "alert/SHOW_ALERT",
          {
            message: errMsg,
            type: "error",
          },
          { root: true }
        );
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      }
      return respData;
    } finally {
      if (respData?.stepName !== "SN_VERIFY_EMAIL_OTP") {
        commit("SET_IS_FETCHING", false);
      }      
      sessionStorageUtils.deleteItem("activeRawId");
    }
  },
  async getRandomPublicKeyForEncryption({ commit }, requestId) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    try {
      await UserService.getPublicKeyToken(requestId || '').then(
        (res) => {
          commit("SET_STATUS", 1);
          const data = res?.data;
          commit("SET_PUBLIC_KEY_DATA", data);
          commit("SET_IS_FETCHING", false);
          return data;
        },
        (error) => {
          commit("SET_STATUS", 2);
          commit("SET_IS_FETCHING", false);
          console.error("err", error);
        }
      );
    } catch (e) {
      console.error(e);
      commit("SET_IS_FETCHING", false);
    }
  },
  async forgotPasswordFlow({ commit }, payload) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    const otpStepsToCheck = [
      "FP_VERIFY_SMS_OTP",
      "FP_VERIFY_EMAIL_OTP",
      "FP_TRIGGER_EMAIL_OTP",
      "FP_TRIGGER_SMS_OTP",
    ];
    try {
      const response = await UserService.forgotPassword(payload);
      const data = CommonClass.methods.$__processDecryptResponse(response.data, process.env.VUE_APP_ENCODEKEY);
      if (data?.successFlag) {
        if (otpStepsToCheck.includes(data?.stepName)) {
          commit("SET_STATUS", 1);
          commit("SET_OTP_DATA", data);
        } else {
          commit("SET_STATUS", 1);
          commit("SET_RESPONSE", data);
        }
        return data;
      } else {
        commit("SET_STATUS", 2);
        commit("SET_RESPONSE", data);
        commit("SET_OTP_DATA", data);
        if (
          ![
            MIDERR_001, 
            MIDERR_003, 
            MIDERR_004, // OTP errCode
            MIDERR_014,
            MIDERR_015,
            MIDERR_016, // OTP errCode
            MIDERR_018,
            MIDERR_022,
            MIDERR_023,
            MIDERR_024,
            MIDERR_026,
            MIDERR_037, // OTP errCode
          ].includes(data?.errCode)
        ) {
          const errMsg = util.getUiErrorByCode(data?.errCode);
          commit(
            "alert/SHOW_ALERT",
            {
              message: errMsg,
              type: "error",
            },
            { root: true }
          );
          document.getElementById("app").scrollIntoView({ behavior: "smooth" });
        }
        return data;
      }
    } catch (e) {
      commit("SET_STATUS", 2);
      const respData = CommonClass.methods.$__processDecryptResponse(e.response.data, process.env.VUE_APP_ENCODEKEY);
      commit("SET_RESPONSE", respData);
      commit("SET_OTP_DATA", respData);
      const errCode = respData?.errCode ?? e.response.status;
      if (
        ![
          MIDERR_001, 
          MIDERR_003, 
          MIDERR_004, // OTP errCode
          MIDERR_014,
          MIDERR_015,
          MIDERR_016, // OTP errCode
          MIDERR_018,
          MIDERR_022,
          MIDERR_023,
          MIDERR_024,
          MIDERR_026,
          MIDERR_037, // OTP errCode
        ].includes(errCode)
      ) {
        const errMsg = util.getUiErrorByCode(errCode);
        commit(
          "alert/SHOW_ALERT",
          {
            message: errMsg,
            type: "error",
          },
          { root: true }
        );
        document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      }
      return respData;
    } finally {
      commit("SET_IS_FETCHING", false);
    }
  },
  async signupFlow({ commit }, payload) {
    commit("SET_STATUS", 0);
    commit("SET_IS_FETCHING", true);
    const otpStepsToCheck = [
      "REG_TRIGGER_SMS_OTP",
      "REG_VERIFY_SMS_OTP",
      "REG_TRIGGER_EMAIL_OTP_GPH",
      "REG_VERIFY_EMAIL_OTP_GPH",
      "REG_TRIGGER_EMAIL_OTP",
      "REG_VERIFY_EMAIL_OTP",
      "REG_NEW_MOBILE_NO",
      "REG_VERIFY_MEMBERID",
    ];
    try {
      const response = await UserService.signup(payload);
      const data = CommonClass.methods.$__processDecryptResponse(response.data, process.env.VUE_APP_ENCODEKEY);
      if (data?.successFlag) {
        commit("SET_STATUS", 1);
        if (otpStepsToCheck.includes(data?.stepName)) {
          commit("SET_OTP_DATA", data);
          if (data?.stepName === "REG_NEW_MOBILE_NO") {
            commit("SET_REGISTER_MOBILE_DATA", data);
          }
        } else {
          commit("SET_RESPONSE", data);
        }
        return data;
      } else {
        commit("SET_STATUS", 2);
        console.log("err", data?.errCode);
        const errMsg = util.getUiErrorByCode(data?.errCode);
        if (data?.errCode !== MIDERR_011) {
          commit("SET_RESPONSE", data);
        }
        if (
          ![
            MIDERR_010,
            MIDERR_009,
            MIDERR_014,
            MIDERR_008,
            MIDERR_017,
            MIDERR_022,
            MIDERR_023,
            MIDERR_024,
            MIDERR_021,
            MIDERR_003,
            MIDERR_004, // OTP errCode
            MIDERR_011,
            MIDERR_016, // OTP errCode
            MIDERR_037, // OTP errCode
            MIDERR_046,
          ].includes(data?.errCode) ||
          (data?.stepName === "REG_BASIC_TO_MAIN_UPGRADE" &&
            data?.errCode === MIDERR_021)
        ) {
          if (
            payload.stepName === "REG_VERIFY_SMS_OTP" &&
            payload.flowName === "signUp"
          ) {
            // const pid = sessionStorageUtils.getItem("pid");
            // window.dataLayer.push({
            //   event: "trackEvent",
            //   "eventDetails.category": "GID - registration",
            //   "eventDetails.action": "click",
            //   "eventDetails.label":
            //     "submit - unsuccessful mobile otp - " + errMsg,
            //   journeyType: "GID registration " + pid,
            //   appId: sessionStorageUtils.getItem("appId"),
            // });
            window.dataLayerPush({
              event: "attempt_registration",
              "eventDetails.category": "EB - registration",
              "eventDetails.label": "submit - unsuccessful new user mobile otp - " + errMsg,
              journeyType: "EB registration personal id",
              appId: "FO EB registration"
            });
          }
          // if (
          //   payload.stepName === "REG_VERIFY_EMAIL_OTP" &&
          //   payload.flowName === "signUp"
          // ) {
          //   const pid = sessionStorageUtils.getItem("pid");
          //   window.dataLayer.push({
          //     event: "trackEvent",
          //     "eventDetails.category": "GID - registration",
          //     "eventDetails.action": "click",
          //     "eventDetails.label":
          //       "submit - unsuccessful email otp great id creation - " + errMsg,
          //     journeyType: "GID registration " + pid,
          //     appId: sessionStorageUtils.getItem("appId"),
          //   });
          // }
          commit(
            "alert/SHOW_ALERT",
            {
              message: errMsg,
              type: "error",
            },
            { root: true }
          );
          document.getElementById("app").scrollIntoView({ behavior: "smooth" });
        }
        return data;
      }
    } catch (e) {
      commit("SET_STATUS", 2);
      const respData = CommonClass.methods.$__processDecryptResponse(e.response.data, process.env.VUE_APP_ENCODEKEY);
      commit("SET_RESPONSE", respData);
      const errCode = respData?.errCode ?? e.response.status;
      const errMsg = util.getUiErrorByCode(errCode);
      if (
        payload.stepName === "REG_VERIFY_SMS_OTP" &&
        payload.flowName === "signUp"
      ) {
        // const pid = sessionStorageUtils.getItem("pid");
        // window.dataLayer.push({
        //   event: "trackEvent",
        //   "eventDetails.category": "GID - registration",
        //   "eventDetails.action": "click",
        //   "eventDetails.label": "submit - unsuccessful mobile otp - " + errMsg,
        //   journeyType: "GID registration " + pid,
        //   appId: sessionStorageUtils.getItem("appId"),
        // });
        window.dataLayerPush({
          event: "attempt_registration",
          "eventDetails.category": "EB - registration",
          "eventDetails.label": "submit - unsuccessful new user mobile otp - " + errMsg,
          journeyType: "EB registration personal id",
          appId: "FO EB registration"
        });
      }
      if (
        ![
          MIDERR_010,
          MIDERR_009,
          MIDERR_014,
          MIDERR_008,
          MIDERR_017,
          MIDERR_022,
          MIDERR_023,
          MIDERR_024,
          MIDERR_021,
          MIDERR_003,
          MIDERR_004, // OTP errCode
          MIDERR_011,
          MIDERR_016, // OTP errCode
          MIDERR_037, // OTP errCode
          MIDERR_046,
        ].includes(errCode)
      ) {
        commit(
          "alert/SHOW_ALERT",
          {
            message: errMsg,
            type: "error",
          },
          { root: true }
        );
      }
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
      return respData.data;
    } finally {
      commit("SET_IS_FETCHING", false);
    }
  },
  setMyInfoDetails({ commit }, payload) {
    if (payload) {
      commit("SET_MY_INFO_DETAILS", payload);
    }
  },
  setIsMobileNumberUpdated({ commit }, payload) {
    commit("SET_IS_MOBILE_NUMBER_UPDATED", payload);
  },
  showTokenError({ commit }, payload) {
    commit(
      "alert/SHOW_ALERT",
      {
        message: payload,
        type: "error",
      },
      { root: true }
    );
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
  },

  showErrorMessage({ commit }, email) {
    commit(
      "alert/SHOW_ALERT",
      {
        message: `Please enter the PIN sent to the email that you registered as your Member ID (You will only receive the email if the Member ID exists): ${email} `,
        type: "warning",
      },
      { root: true }
    );
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
  },

  displayOTPErrorMessage({ commit }, errorMessage) {
    commit(
      "alert/SHOW_ALERT",
      {
        message: errorMessage,
        type: "error",
      },
      { root: true }
    );
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
  },
  deleteData({ commit }) {
    clearMemberIdRequestID();
    commit("DELETE_DATA");
  },

  setMemberId({ commit }, memberId) {
    commit("SET_MEMBER_ID", memberId);
  },

  setExistingMemberId({ commit }, memberId) {
    commit("SET_EXISTING_MEMBER_ID", memberId);
  },
  setCurrentStep({ commit }, currenStep) {
    commit("SET_CURRENT_STEP", currenStep);
  },
  setStepperMaxLength({ commit }, length) {
    commit("SET_STEPPER_MAXLENGTH", length);
  },
  setSignUpMobile({ commit }, value) {
    commit("SET_SIGNUP_MOBILE", value);
  },
  setIsFetching({ commit }, value) {
    commit("SET_IS_FETCHING", value);
  },
};
